import styled from 'styled-components'

import { ImgProps } from './types'

export default styled.img<ImgProps>``
